module.exports = __webpack_public_path__ + "img/calendar-lesson.8777ef52.svg";